import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowRightIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M7.79977 13.63C7.68791 13.7472 7.62549 13.903 7.62549 14.065C7.62549 14.227 7.68791 14.3828 7.79977 14.5L8.52977 15.23C8.64576 15.3442 8.802 15.4082 8.96477 15.4082C9.12755 15.4082 9.28379 15.3442 9.39977 15.23L14.1898 10.43C14.2472 10.3741 14.2929 10.3072 14.3241 10.2334C14.3553 10.1595 14.3713 10.0802 14.3713 10C14.3713 9.91984 14.3553 9.84049 14.3241 9.76663C14.2929 9.69278 14.2472 9.62592 14.1898 9.57001L9.39977 4.77001C9.28379 4.65581 9.12755 4.5918 8.96477 4.5918C8.802 4.5918 8.64576 4.65581 8.52977 4.77001L7.79977 5.50001C7.68791 5.61721 7.62549 5.77299 7.62549 5.93501C7.62549 6.09703 7.68791 6.25282 7.79977 6.37001L11.4398 10L7.79977 13.63Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowRightIcon;
